import { useRef } from 'react';
import { usePrevious } from '../usePrevious';
/**
 * get value when prev listen value change
 * @param cb that method you want calculate to get value
 * @param listenCb prev compare listener value
 */
export var useChange = function (cb, listenCb) {
    var countRef = useRef(0);
    var valueRef = useRef();
    var prev = usePrevious(listenCb);
    var curr = listenCb();
    if (countRef.current === 0 || prev !== curr) {
        countRef.current = 1;
        valueRef.current = cb(prev, curr);
    }
    return valueRef.current;
};
/**
 * get value when prev deps one of array value change
 * @param cb that method you want calculate to get value
 * @param deps prev compare value array
 */
export var useDepsChange = function (cb, deps) {
    var countRef = useRef(0);
    var valueRef = useRef();
    var prev = usePrevious(function () { return deps; }, true);
    var curr = deps;
    if (countRef.current === 0 ||
        curr.some(function (dep, index) { return dep !== prev[index]; })) {
        countRef.current = 1;
        valueRef.current = cb(prev, curr);
    }
    return valueRef.current;
};
